/**
 * Point 11 (Monday 12950051387 follow-up, Addison: "inputs must be genuinely required and show a
 * visible problem state when one is missed") — the two small decisions `NewRunModal.tsx` needs
 * for every required field's `invalid` prop, pulled out as pure functions (this codebase's own
 * convention for exactly this shape of decision — see `ControlRoomScreen.tsx`'s `pageBodyState`/
 * `railPaneState`) so they're unit-testable without a DOM renderer.
 */

/** Every plain required Select/Input (season, week, category, DATE, the category-specific
 *  fields) — red only once the customer has tried to submit at least once (`attempted`) AND the
 *  field is still empty. Never red before that first attempt. */
export function requiredFieldInvalid(
  attempted: boolean,
  filled: boolean
): boolean {
  return attempted && !filled;
}

/** The three link-source Inputs (collection / saved search / assets) each already show a red
 *  state for malformed-but-non-empty text as the customer types, independent of `attempted` —
 *  this is that existing "doesn't look like a valid link" signal. Once the customer has tried to
 *  submit, it folds together with the plain required check: a still-empty field OR a
 *  still-unparseable one both read as invalid, not just the empty case. */
export function sourceFieldInvalid(
  attempted: boolean,
  hasSource: boolean,
  malformedWhileTyping: boolean
): boolean {
  return attempted ? !hasSource : malformedWhileTyping;
}
